<template>
  <div>
    <user-login>
      <span
        slot="title"
        v-if="title"
        class="title"
      >{{ title }}</span>
    </user-login>
  </div>
</template>

<script>
import UserLogin from '@/components/login/UserLogin.vue'
import { formatDate } from '@/utils/shared'
import login from '@/client/modules/login.js'
export default {
  name: 'Login',
  components: {
    UserLogin
  },
  data () {
    return {
      title: '快速登录'
    }
  },
  mounted () {
    window.onbeforeunload = function () {
      const stay_time = parseInt(
        (new Date().getTime() - performance.timing.fetchStart)
      )
      login.REPORT.reportLoginPageShow({ stay_time, page_show: 0 })
      localStorage.setItem('login-stay-time', stay_time)
    }
  },
  // eslint-disable-next-line handle-callback-err
  errorCaptured (err, vm, info) {
    const show_time = formatDate(new Date())
    login.REPORT.reportLoginPageShow({ show_time, page_show: 2 })
    return false
  }
}
</script>
